import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { XIcon, MenuAlt3Icon } from '@heroicons/react/outline';
import { createPortal } from 'react-dom';
import logoWaras from '../assets/img/waras-logo-dark.png';
import { navigation } from '../data/navigation';
import { COMPANY } from '../data/content';

const pathOf = (item) =>
  item.section ? { pathname: item.href, hash: `#${item.section}` } : item.href;

const NavMobile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname, location.hash]);

  const isActive = (item) => {
    if (item.section) return location.pathname === '/' && location.hash === `#${item.section}`;
    if (item.href === '/') return location.pathname === '/' && !location.hash;
    return location.pathname === item.href;
  };

  const menuContent = isOpen ? (
    <>
      <button
        type='button'
        aria-label='Cerrar menú'
        onClick={() => setIsOpen(false)}
        className='fixed inset-0 bg-ink/40 z-[9998]'
      />
      <div className='fixed top-0 right-0 bottom-0 w-full max-w-sm bg-surface-card z-[9999] shadow-card-hover flex flex-col'>
        <div className='flex items-center justify-between px-5 py-4 border-b border-line'>
          <Link to='/' onClick={() => setIsOpen(false)}>
            <img src={logoWaras} alt='Waras Delivery' className='h-12 w-auto object-contain' />
          </Link>
          <button
            type='button'
            onClick={() => setIsOpen(false)}
            className='p-2 rounded-md text-ink hover:bg-surface-alt'
            aria-label='Cerrar'
          >
            <XIcon className='w-6 h-6' />
          </button>
        </div>
        <ul className='flex flex-col p-4 gap-1 list-none m-0'>
          {navigation.map((item) => {
            const active = isActive(item);
            return (
              <li key={item.name}>
                <Link
                  to={pathOf(item)}
                  onClick={() => setIsOpen(false)}
                  className={`block w-full text-left px-4 py-3 rounded-lg text-base font-semibold ${
                    active ? 'bg-accent-light text-accent' : 'text-ink hover:bg-surface-alt'
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            );
          })}
        </ul>
        <div className='mt-auto p-4 border-t border-line'>
          <a
            href={COMPANY.playStore}
            target='_blank'
            rel='noopener noreferrer'
            className='btn btn-md w-full'
            onClick={() => setIsOpen(false)}
          >
            Descargar app
          </a>
        </div>
      </div>
    </>
  ) : null;

  return (
    <>
      <button
        type='button'
        onClick={() => setIsOpen(true)}
        className='p-2 rounded-md text-ink border border-line hover:bg-surface-alt'
        aria-label='Abrir menú'
      >
        <MenuAlt3Icon className='w-6 h-6' />
      </button>
      {typeof document !== 'undefined' && createPortal(menuContent, document.body)}
    </>
  );
};

export default NavMobile;
